import { render, staticRenderFns } from "./cacheManage.vue?vue&type=template&id=47d81827&scoped=true"
import script from "./cacheManage.vue?vue&type=script&lang=js"
export * from "./cacheManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d81827",
  null
  
)

export default component.exports